import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { mapPersonsToBrokers } from './shared/broker-utils';

export const GET_OFFICE_PERSONS = graphql(`
  query getOfficePersons($officeId: String!) {
    persons(filters: { officeUuid: $officeId }) {
      edges {
        node {
          uuid
          firstName
          lastName
          agent
          status
        }
      }
    }
  }
`);

export function useGetOfficeBrokers({
  officeId,
  enabled = true,
}: {
  officeId: string;
  enabled?: boolean;
}) {
  const { loading, error, data } = useQuery(GET_OFFICE_PERSONS, {
    variables: {
      officeId,
    },
    skip: !enabled || !officeId,
  });

  const brokers = useMemo(() => {
    if (!data?.persons?.edges?.length) return [];

    return mapPersonsToBrokers(data.persons.edges, {
      officeName: '—',
    });
  }, [data]);

  return {
    error,
    loading,
    data,
    brokers,
  };
}
